import React, { useState, useEffect, useRef } from 'react'
import {
  useSpring,
  animated as a,
  useChain,
  config,
  interpolate,
} from 'react-spring'

// SVGs
import Github from '../../svg/github.svg'
import LinkedIn from '../../svg/linkedin.svg'

// Component
const Contact = ({ isVisible }) => {
  // Load/View detection
  const [loaded, setLoaded] = useState(false)

  const load = isVisible => {
    if (isVisible && !loaded) {
      setLoaded(true)
    }
  }

  useEffect(() => {
    load(isVisible)
  }, [isVisible])

  // Animations
  let widthAnimRef = useRef()
  let transformAnimRef = useRef()

  const { width, opacity } = useSpring({
    from: {
      width: 0,
      opacity: 0,
    },
    to: {
      width: 100,
      opacity: 1,
    },
    config: config.wobbly,
    ref: widthAnimRef,
  })

  const { scale, rotate } = useSpring({
    from: {
      scale: 0,
      rotate: 0,
    },
    to: async next => {
      await next({ scale: 1.3, rotate: 360 })
      await next({ scale: 1, rotate: 360 })
    },
    ref: transformAnimRef,
  })

  useChain(loaded ? [widthAnimRef, transformAnimRef] : [], [0.2, 0.4])

  return (
    <div name="contact" id="contact" className="contact">
      <div className="contact-head">
        <h1>Contacts</h1>
        <a.hr
          style={{
            width: width.interpolate(width => `${width}%`),
          }}
          className="contact-under"
        />
      </div>
      <h3>Get in touch with me</h3>
      <form
        className="contact-form"
        name="contact"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="contact" />
        <label htmlFor="name">
          Name :
          <a.input
            style={{
              opacity,
              width: width.interpolate(width => `${width}%`),
            }}
            type="text"
            name="name"
            id="name"
            placeholder="Name"
            required
          />
        </label>
        <label htmlFor="email">
          Email :
          <a.input
            style={{
              opacity,
              width: width.interpolate(width => `${width}%`),
            }}
            type="email"
            name="email"
            id="email"
            placeholder="Email"
            required
          />
        </label>
        <label htmlFor="message">
          Message :
          <a.textarea
            style={{
              opacity,
              width: width.interpolate(width => `${width}%`),
            }}
            name="message"
            id="message"
            placeholder="Your message"
            required
          />
        </label>
        <a.button type="submit" id="submit">
          Submit
        </a.button>
      </form>
      <div className="connects">
        <a.div
          style={{
            transform: interpolate(
              [scale, rotate],
              (scale, rotate) => `scale(${scale}) rotate(${rotate}deg)`
            ),
          }}
          className="site github"
        >
          <a
            href="https://github.com/PragunSaini"
            target="_blank"
            rel="noopener noreferrer"
          >
            Github
            <Github />
          </a>
        </a.div>
        <a.div
          style={{
            transform: interpolate(
              [scale, rotate],
              (scale, rotate) => `scale(${scale}) rotate(${rotate}deg)`
            ),
          }}
          className="site linkedin"
        >
          <a
            href="https://linkedin.com/in/pragunsaini"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
            <LinkedIn />
          </a>
        </a.div>
      </div>
    </div>
  )
}

export default Contact
